<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter-h"><span>What to Do on New Year’s Eve — I</span></p>
<p class="normal"><span class="dropcap">T</span><span class="smallcaps">HERE</span> comes a time in life when it is unseemly to awaken late in the afternoon of January 1 on someone’s snooker table, naked save for a tiny conical hat (whose elastic strap has ridden up to just under your nose), shriveled tuxedo pants, and a crust of onion dip and confetti. In your productive middle years, you tend to feel not only your responsibilities but also your hangovers deeply: way down in the nucleoli of your every body cell, for up to three months. Furthermore you find those little hat-straps to be more and more irritating, even under the chin (even if you still have only one of those), and even <i>during</i> the party.</p>
<p class="indent">New Year’s Eve becomes a time not to blow off steam, but to behave yourself. This realization may come as more of a relief than steam blowing does. “Nothing is more hopeless than a scheme of merriment,” wrote Dr. Johnson. There is no American merrymaking, or merry faking, so forced and obligatory as a New Year’s Eve party. There is also no hangover — not to dwell on this point — so profound as that induced by a lot of champagne on top of a lot of, say, bourbon and a number of sips of various fellow celebrants’ apricot and artichoke and so on liqueurs.</p>
<p class="indent">What, then, is to be done on December 31? Should the day be ignored altogether? Or is there a way to ring out the old and in the new without leaving yourself with the feeling that you have spent forty-eight hours inside a gong? Let us consider some of the possibilities.</p>
<table class="table-1">
<tbody><tr>
<td class="table-5">1.</td>
<td class="table-3">Ignore December 31 altogether. The trouble with this is that it may become a habit. If so widely acknowledged a day as New Year’s Eve can be ignored, then why not the following Monday? Why not every Monday? Why not February? Why not the entire new year? These are all good questions. If you hold a position of mature responsibility, it is better not to ask them.</td>
</tr>
<tr>
<td class="table-5">2.</td>
<td class="table-3">Celebrate with a magnum of sparkling water, a bowl of light watercress dip, and some cauliflower sprigs. Unfortunately this pretty much comes under the heading of number 1.</td>
</tr>
<tr>
<td class="table-5">3.</td>
<td class="table-3">Celebrate New Year’s Eve, 1958. This seems worth a try, until you realize that it is not worth a try. You drank worse things in 1958 than you do now. And where are you going to find a pair of pink-and-black socks?</td>
</tr>
<tr>
<td class="table-5">4.</td>
<td class="table-3">Dress up like the New Year and lie in a sensory-deprivation tank until midnight. The trouble with this is, what if it gets back to the people in the office? Or what if, being made to feel born-again, you never get back to the office?</td>
</tr>
<tr>
<td class="table-5">5.</td>
<td class="table-3">Stay home, watch Times Square on television, and at midnight, instead of kissing thirty-four wives in one minute, kiss your own wife for thirty-four minutes. You need not feel maturely responsible for whatever happens next.</td>
</tr>
</tbody></table>
<p class="indenta">My New Year’s resolution is to try number 5. It is too late to resolve to try it this New Year’s Eve, however. This New Year’s Eve, out of a mature sense of obligation, I am going to attend a party. Maybe a <i>bit</i> of champagne, but I intend to lay off the dip as soon as traces of it reach my first knuckles. And I will take the sensible precaution of placing a bit of adhesive tape under my nose.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter16.vue?ac4cbad6